import { Link } from 'react-router-dom';

const documents = [
  { title: 'Terms of Service', desc: 'The rules and conditions for using the VSENDS platform.', href: '/legal/terms' },
  { title: 'Privacy Policy', desc: 'How we collect, use, store, and protect your personal data.', href: '/legal/privacy' },
  { title: 'Cookie Policy', desc: 'Details about cookies, tracking technologies, and your choices.', href: '/legal/cookies' },
  { title: 'Data Processing Agreement', desc: 'Defines the GDPR relationship between you (Controller) and VSENDS (Processor).', href: '/legal/dpa' },
  { title: 'Anti-Spam Policy', desc: 'Our zero-tolerance stance on spam and email abuse.', href: '/legal/anti-spam' },
  { title: 'Acceptable Use Policy', desc: 'What you can and cannot do on the VSENDS platform.', href: '/legal/aup' },
  { title: 'AI Disclosure & Safety Policy', desc: 'How our AI features work, their limitations, and your responsibilities.', href: '/legal/ai-policy' },
  { title: 'Refund Policy', desc: 'How payments, cancellations, and refunds are handled.', href: '/legal/refunds' },
  { title: 'GDPR Compliance', desc: 'How VSENDS meets GDPR requirements and how you can exercise your rights.', href: '/legal/gdpr' },
  { title: 'Security Policy', desc: 'The technical and organisational measures we use to protect your data.', href: '/legal/security' },
];

export default function LegalHub() {
  return (
    <div className="min-h-screen bg-gray-50">
      <main className="max-w-3xl mx-auto py-12 px-4">
        <h1 className="text-3xl font-bold text-gray-900 mb-4">Legal & Compliance</h1>
        <p className="text-gray-600 mb-4">
          At VSENDS, we are committed to transparency, data protection, and regulatory compliance.
          This page provides access to all legal documents governing the use of our platform.
        </p>
        <p className="text-gray-600 mb-6">
          VSENDS is a trading name of <strong className="text-gray-900">V CAN RESOURCES LIMITED</strong>, Company No. <strong className="text-gray-900">13759348</strong>, registered in England & Wales.
        </p>
        <p className="text-gray-600 mb-8">
          For support or legal enquiries: <br />
          <a href="mailto:support@vsends.com" className="text-blue-600 hover:underline">support@vsends.com</a> |{' '}
          <a href="mailto:vg@vcanresources.com" className="text-blue-600 hover:underline">vg@vcanresources.com</a>
        </p>

        <h2 className="text-xl font-semibold text-gray-900 mb-4">Legal Documents</h2>
        <div className="space-y-4">
          {documents.map((doc) => (
            <Link
              key={doc.href}
              to={doc.href}
              className="block p-5 bg-white border border-gray-200 rounded-xl hover:border-blue-300 hover:shadow-md transition-all"
            >
              <h3 className="font-semibold text-gray-900">{doc.title}</h3>
              <p className="text-sm text-gray-500 mt-1">{doc.desc}</p>
            </Link>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-gray-200">
          <h2 className="text-xl font-semibold text-gray-900 mb-4">Contact & Compliance</h2>
          <div className="bg-white border border-gray-200 rounded-xl p-6 space-y-3">
            <div>
              <p className="text-sm font-medium text-gray-900">Data Protection Officer</p>
              <p className="text-sm text-gray-500">Handled internally by V CAN RESOURCES LIMITED</p>
              <a href="mailto:vg@vcanresources.com" className="text-sm text-blue-600 hover:underline">vg@vcanresources.com</a>
            </div>
            <div>
              <p className="text-sm font-medium text-gray-900">Registered Office</p>
              <p className="text-sm text-gray-500">32 Abbey Drive, Dartford, England, DA2 7WP</p>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
